import React, { type ReactNode } from 'react'
import classNames from 'classnames'
import { Modal } from 'react-bootstrap'
import zocksLogoSrc from '../../../assets/ZocksLogoFullBlack.svg?url'
import styles from './PostConnectStepFrame.module.scss'

interface PostConnectModalShellProps {
  children: ReactNode
  onClose?: () => void
}

export const PostConnectModalShell: React.FC<PostConnectModalShellProps> = ({ children, onClose }) => (
  <Modal show fullscreen backdrop='static' keyboard={false} centered>
    <Modal.Body className='d-flex flex-column align-items-center justify-content-center p-4 position-relative overflow-hidden'>
      {onClose ? <button className='btn btn-close position-absolute top-0 end-0 m-5' onClick={onClose} aria-label='Close' /> : null}
      <div className='position-absolute top-0 start-0 p-3'>
        <img src={zocksLogoSrc} alt='Zocks' className={styles.logo} />
      </div>
      <div className={classNames(styles.wave, 'position-absolute bottom-0 start-0 end-0 pe-none')} aria-hidden='true' />
      {children}
    </Modal.Body>
  </Modal>
)
